export const FETCH_ADDRESSES = 'app/core/reducers/addresses/FETCH_ADDRESSES';
export const CREATE_ADDRESS = 'app/core/reducers/addresses/CREATE_ADDRESS';
export const UPDATE_ADDRESS = 'app/core/reducers/addresses/UPDATE_ADDRESS';
export const DELETE_ADDRESS = 'app/core/reducers/addresses/DELETE_ADDRESS';
